import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { eq } from 'ember-truth-helpers';

type TabValue = 'visits' | 'aliases' | 'documents';

interface TabsSignature {
  Args: {
    activeTab: TabValue;
    onChange: (tab: TabValue) => void;
    showDocuments?: boolean;
  };
  Element: HTMLDivElement;
}

export default <template>
  <div role="tablist" class="flex space-x-6 border-b border-carbon-10 mb-2" ...attributes>
    <button
      type="button"
      role="tab"
      id="tab-visits"
      aria-selected={{eq @activeTab "visits"}}
      aria-controls="tabpanel-visits"
      class="pb-2 px-1 text-sm font-medium border-b-2 transition-colors duration-200
        {{if
          (eq @activeTab 'visits')
          'border-red-50 text-red-50'
          'border-transparent text-carbon-50 hover:text-red-50 hover:border-red-50'
        }}"
      {{on "click" (fn @onChange "visits")}}
      data-test-tab="visits"
    >
      Visits
    </button>

    <button
      type="button"
      role="tab"
      id="tab-aliases"
      aria-selected={{eq @activeTab "aliases"}}
      aria-controls="tabpanel-aliases"
      class="pb-2 px-1 text-sm font-medium border-b-2 transition-colors duration-200
        {{if
          (eq @activeTab 'aliases')
          'border-red-50 text-red-50'
          'border-transparent text-carbon-50 hover:text-red-50 hover:border-red-50'
        }}"
      {{on "click" (fn @onChange "aliases")}}
      data-test-tab="aliases"
    >
      Aliases
    </button>

    {{#if @showDocuments}}
      <button
        type="button"
        role="tab"
        id="tab-documents"
        aria-selected={{eq @activeTab "documents"}}
        aria-controls="tabpanel-documents"
        class="pb-2 px-1 text-sm font-medium border-b-2 transition-colors duration-200
          {{if
            (eq @activeTab 'documents')
            'border-red-50 text-red-50'
            'border-transparent text-carbon-50 hover:text-red-50 hover:border-red-50'
          }}"
        {{on "click" (fn @onChange "documents")}}
        data-test-tab="documents"
      >
        Documents
      </button>
    {{/if}}
  </div>
</template> satisfies TOC<TabsSignature>;
